import { type FC } from 'react';
import classnames from 'classnames';
import { graphql, useFragment } from 'react-relay';

import dibsCss from 'dibs-css';
import { Button } from 'dibs-elements/exports/Button.tsx';

import { useHomePageContext } from '../HomePageContext.tsx';
import { trackShopTheEditClick } from './videoComponentTrackingHelpers.ts';

import { type HpSharedVideoComponentTitle_componentModule$key } from './__generated__/HpSharedVideoComponentTitle_componentModule.graphql.ts';

type Props = { componentModule: HpSharedVideoComponentTitle_componentModule$key };

const componentModuleFragment = graphql`
    fragment HpSharedVideoComponentTitle_componentModule on VideoModule {
        eyebrow
        title
        ctaText
        ctaLink
    }
`;

const HpSharedVideoComponentTitle: FC<Props> = ({ componentModule: componentModuleRef }) => {
    const { isMobile } = useHomePageContext();
    const componentModule = useFragment(componentModuleFragment, componentModuleRef);
    const { eyebrow, title, ctaText, ctaLink } = componentModule || {};

    if (!eyebrow && !title && !ctaText && !ctaLink) {
        return null;
    }

    return (
        <>
            <div
                className={classnames({
                    [dibsCss.sassyFontHeaderMediumItalic]: !isMobile,
                    [dibsCss.sassyFontHeaderSmallItalic]: isMobile,
                })}
            >
                {eyebrow}
            </div>
            <div
                className={classnames(dibsCss.mtXsmall, {
                    [dibsCss.sassyFontHeaderXxLarge]: !isMobile,
                    [dibsCss.sassyFontHeaderSizeMedium]: isMobile,
                })}
            >
                {title}
            </div>
            {ctaText && ctaLink && (
                <div
                    className={classnames({
                        [dibsCss.mtSmall]: isMobile,
                        [dibsCss.mtMedium]: !isMobile,
                    })}
                >
                    <Button
                        type="transparent"
                        size={isMobile ? 'medium' : 'large'}
                        href={ctaLink}
                        onClick={trackShopTheEditClick}
                    >
                        {ctaText}
                    </Button>
                </div>
            )}
        </>
    );
};

export default HpSharedVideoComponentTitle;
